import { httpCreators, HttpResponse } from '@ppvrbh/merchant-frontend-core';
import { call, put, takeLatest } from 'redux-saga/effects';
import { MODIFIER_ITEM_REQUEST_ID_LIST } from './modifier-item-constant';
import { modifierItemCreators } from './modifier-item-action';
import { MODIFIER_ITEM_KEY } from './modifier-item-reducer';
import { CallModifierItemsAction, MODIFIER_ITEM_ACTION_TYPE } from './modifier-item-type';
import { ModifierItemService } from './modifier-item-service';
import { message } from 'antd';

function* callModifierItems(action: CallModifierItemsAction) {
  yield put(httpCreators.request({
    id: MODIFIER_ITEM_REQUEST_ID_LIST.GET_MODIFIER_ITEMS,
    sagaHandler: getModifierItemsHandler,
    service: ModifierItemService.getModifierItems,
    serviceParams: action.payload,
    callbackParams: { keyword: action.payload?.keyword },
  }));
}

function* getModifierItemsHandler(resp: HttpResponse, callbackParams?: { keyword?: string }) {
  if (resp.success) {
    yield put(modifierItemCreators.setModifierItemState(MODIFIER_ITEM_KEY.MODIFIER_ITEMS, resp.data.menuModifierItems));
    yield put(modifierItemCreators.setModifierItemState(MODIFIER_ITEM_KEY.META, resp.data.meta));
    if (!callbackParams?.keyword) {
      yield put(modifierItemCreators.setModifierItemState(MODIFIER_ITEM_KEY.TOTAL_ITEMS, resp.data.meta?.totalItems));
    }
  } else {
    yield put(modifierItemCreators.setModifierItemState(MODIFIER_ITEM_KEY.MODIFIER_ITEMS, []));
    yield put(modifierItemCreators.setModifierItemState(MODIFIER_ITEM_KEY.META, undefined));
  }
}

function* toggleStatusHandler(resp: HttpResponse, callbackParams: () => void) {
  if (resp.success) {
    yield call(callbackParams);
  } else {
    const messageError = resp.data?.description;
    message.error(messageError || 'Toggle modifier item status failed');
  }
}

function* callbackHandler(resp: HttpResponse, callbackParams: () => void) {
  if (resp.success) {
    yield call(callbackParams);
  }
}

function* callbackWithErrorHandler(resp: HttpResponse, callbackParams: { onSuccess: () => void; onError?: (keys: string[]) => void }) {
  if (resp.success) {
    yield call(callbackParams.onSuccess);
  } else {
    const translationKeys: string[] = resp.data?.translationKey ?? [];
    if (translationKeys.length > 0 && callbackParams?.onError) {
      callbackParams.onError(translationKeys);
    } else {
      message.error(resp.data?.description || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
    }
  }
}

export const modifierItemSagas = {
  callModifierItems,
  getModifierItemsHandler,
  callbackHandler,
  callbackWithErrorHandler,
  toggleStatusHandler,
  watchers: [
    takeLatest(MODIFIER_ITEM_ACTION_TYPE.CALL_MODIFIER_ITEMS, callModifierItems),
  ],
};
